var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('h1',{staticClass:"subtitle has-text-centered"},[_c('go-to-dashboard'),_vm._v("   "+_vm._s(`${_vm.storeBeingManaged.storeInfo.name}`)+" ")],1),_c('hr')])
}
var staticRenderFns = []

export { render, staticRenderFns }